export const editorConfig = {
  readonly: false,
  enter: 'br' as const,
};
